import { getInlineAdConfig } from 'SharedHelpers/getInlineAdConfig';

export const getIndexPageAdConfig = adCount => ({
  ...getInlineAdConfig(adCount).props,
  label: 'Advertisement',
  extraClassNames: {
    '-full-width': true,
    'hide-mobile': true,
    'hide-tablet': true,
  },
});
